module.exports = __webpack_public_path__ + "img/dep_gamestoysandsports@2x.8d692d14.png";